/** Common dial codes — default Canada (+1) for Spike Sports. */
export const PHONE_COUNTRY_OPTIONS = [
  { dial: "+1", label: "Canada (+1)", iso: "CA" },
  { dial: "+1", label: "United States (+1)", iso: "US" },
  { dial: "+44", label: "United Kingdom (+44)", iso: "GB" },
  { dial: "+91", label: "India (+91)", iso: "IN" },
  { dial: "+61", label: "Australia (+61)", iso: "AU" },
  { dial: "+971", label: "UAE (+971)", iso: "AE" },
  { dial: "+92", label: "Pakistan (+92)", iso: "PK" },
  { dial: "+63", label: "Philippines (+63)", iso: "PH" },
  { dial: "+86", label: "China (+86)", iso: "CN" },
  { dial: "+33", label: "France (+33)", iso: "FR" },
  { dial: "+49", label: "Germany (+49)", iso: "DE" },
];

export const DEFAULT_PHONE_COUNTRY = PHONE_COUNTRY_OPTIONS[0];

export function digitsOnly(value) {
  return (value || "").replace(/\D/g, "");
}

/** Build full phone string for API (digits only, includes country code). */
export function formatPhoneForApi(dialCode, nationalNumber) {
  const dialDigits = digitsOnly(dialCode);
  let national = digitsOnly(nationalNumber);
  if (!dialDigits || !national) return "";

  // Strip leading trunk zero when user typed local format
  if (national.startsWith("0")) national = national.replace(/^0+/, "");

  // North America: if user included country code in national field, use as-is when long enough
  if (dialDigits === "1" && national.length === 11 && national.startsWith("1")) {
    return national;
  }
  if (dialDigits === "1" && national.length === 10) {
    return `1${national}`;
  }

  return `${dialDigits}${national}`;
}

export function isValidPhoneForApi(dialCode, nationalNumber) {
  const combined = formatPhoneForApi(dialCode, nationalNumber);
  const len = combined.length;
  return len >= 10 && len <= 15;
}
